import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import BreakableTypography from 'components/@common/BreakableTypography';
import { ModalContainer, ModalContent, ModalFooter, ModalHeader } from 'components/@common/Modal';
import PageContainer from 'components/@layout/PageContainer';
import GET_CLASSROOM from 'graph/classroom/get-classroom-query';
import useParseActionRouteParams from 'hooks/route-action/use-parse-action-route-params';
import { Button } from '@material-ui/core';
import useStore from 'store';
import SettingsContainer from './SettingsContainer';

const ClassroomSettingsModal: React.FC = () => {
  const { t } = useTranslation('SettingsModal');
  const [, { closeModal }] = useStore();
  const { classroomId } = useParseActionRouteParams();
  const { data, loading, error } = useQuery(GET_CLASSROOM, {
    variables: { id: Number(classroomId) }
  });

  return (
    <PageContainer loading={loading} error={error ? 'Failed to load classes' : null}>
      <ModalContainer
        Header={
          <ModalHeader>
            <BreakableTypography variant="h2" component="h1">
              {t('Manage Class Settings')} - <b>{data?.classroom?.name}</b>
            </BreakableTypography>
          </ModalHeader>
        }
        Footer={
          <ModalFooter
            Actions={
              <Button
                aria-label={t('Close Settings Modal')}
                variant="contained"
                color="secondary"
                disableElevation
                onClick={closeModal}
              >
                {t('Close')}
              </Button>
            }
          />
        }
      >
        <ModalContent>{data && <SettingsContainer classroom={data.classroom} />}</ModalContent>
      </ModalContainer>
    </PageContainer>
  );
};

export default ClassroomSettingsModal;
